export enum UnitType {
  METRIC = 'METRIC',
  IMPERIAL = 'IMPERIAL',
  NAUTICAL = 'NAUTICAL',
}

export const Unit = {
  Distance: {
    dm: 'dm',
    m: 'm',
    meter: 'meter',
    km: 'km',
    kilometer: 'kilometer',
    ft: 'ft',
    foot: 'foot',
    mi: 'mi',
    mile: 'mile',
    ftm: 'ftm',
    fathom: 'fathom',
    nmi: 'nmi',
    nauticalMile: 'nautical-mile',
  },
  Elevation: { m: 'm', meter: 'meter', ft: 'ft', foot: 'foot', ftm: 'ftm', fathom: 'fathom' },
  Velocity: {
    kmh: 'km/h',
    kilometerPerHour: 'kilometer/hour',
    mph: 'mph',
    milesPerHour: 'miles/hour',
    kn: 'kn',
    knot: 'knot',
  },
  Pace: { minPerKm: 'min/km', minPerMi: 'min/mi', minPerNmi: 'min/nmi' },
} as const;

export type DistanceUnit = (typeof Unit.Distance)[keyof typeof Unit.Distance];
export type VelocityUnit = (typeof Unit.Velocity)[keyof typeof Unit.Velocity];
export type ElevationUnit = (typeof Unit.Elevation)[keyof typeof Unit.Elevation];
export type PaceUnit = (typeof Unit.Pace)[keyof typeof Unit.Pace];
